// schema naming conversions:
// material_mode -> material
// material.none -> material.geometry_only
// material.normal -> material.basic
// input_image.image_uri -> input_image.asset_id

import hyper3dImageTo3dModelGen2 from './Schema/hyper3d-image-to-3d-model_gen2'
import hyper3dRetextureModelPro from './Schema/hyper3d-retexture-model_pro'
import hyper3dTextTo3dModelGen2 from './Schema/hyper3d-text-to-3d-model_gen2'
import meshyImageTo3dModelPro from './Schema/meshy-image-to-3d-model_pro'
import meshyMeshSimplificationModelPro from './Schema/meshy-mesh-simplification-model_pro'
import meshyRetextureModelPro from './Schema/meshy-retexture-model_pro'
import meshyTextTo3dModelPro from './Schema/meshy-text-to-3d-model_pro'
import tencentImageTo3dModelPro from './Schema/tencent-image-to-3d-model_pro'
import tencentMeshSegmentationModelPro from './Schema/tencent-mesh-segmentation-model_pro'
import tencentMeshSimplificationModelPro from './Schema/tencent-mesh-simplification-model_pro'
import tencentRetextureModelPro from './Schema/tencent-retexture-model_pro'
import tencentTextTo3dModelPro from './Schema/tencent-text-to-3d-model_pro'
import tripo3dImageTo3dModelDefault from './Schema/tripo3d-image-to-3d-model_default'
import tripo3dMeshSegmentationModelDefault from './Schema/tripo3d-mesh-segmentation-model_default'
import tripo3dMeshSimplificationModelDefault from './Schema/tripo3d-mesh-simplification-model_default'
import tripo3dRetextureModelDefault from './Schema/tripo3d-retexture-model_default'
import tripo3dTextTo3dModelDefault from './Schema/tripo3d-text-to-3d-model_default'

export const MODEL_SOURCES = [
  tencentImageTo3dModelPro,
  tencentMeshSimplificationModelPro,
  tencentMeshSegmentationModelPro,
  meshyMeshSimplificationModelPro,
  tripo3dMeshSimplificationModelDefault,
  tripo3dMeshSegmentationModelDefault,
  tencentRetextureModelPro,
  tripo3dRetextureModelDefault,
  hyper3dRetextureModelPro,
  meshyRetextureModelPro,
  tencentTextTo3dModelPro,
  tripo3dImageTo3dModelDefault,
  tripo3dTextTo3dModelDefault,
  meshyTextTo3dModelPro,
  meshyImageTo3dModelPro,
  hyper3dTextTo3dModelGen2,
  hyper3dImageTo3dModelGen2,
]
